/* -------------------------------------------------------------------------------------------------
 * I18next
 * -----------------------------------------------------------------------------------------------*/

enum I18NEXT {
	routeProfileAddressesIndex = 'route-profile-addresses-index',
	uiPager = 'ui-pager',
}

/* -------------------------------------------------------------------------------------------------
 * Route loader
 * -----------------------------------------------------------------------------------------------*/

enum ROUTE_LOADER {
	root = 'root',
	current = 'routes/($lang).profile.addresses._index',
	profile = 'routes/($lang).profile',
	profileAddresses = 'routes/($lang).profile.addresses',
}

/* -----------------------------------------------------------------------------------------------*/

export {
	I18NEXT as PROFILE_ADDRESSES_INDEX_I18NEXT,
	ROUTE_LOADER as PROFILE_ADDRESSES_INDEX_ROUTE_LOADER,
}
